import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import usageConsumptionPropTypes from "../../propTypes/usageConsumption";
import {t} from "../../Translations";
import Api from '../../Api';
import Annotation from "../widgets/Annotation";
import VehicleDetail from "../widgets/VehicleDetail";
import staticimg from './staticimg.png'
import Configuration from "../../Configuration";

/**
 * Component displaying usage consumption results
 */
class UsageConsumptionResult extends React.Component
{
    static propTypes = {
        className: PropTypes.string,

        // Contain steps data
        data: PropTypes.object,

        // The user chosen vehicle detail, in human reading format
        vehicleDetail: PropTypes.object,

        // Data returned by the usage consumption calculation API
        usageConsumptionData: usageConsumptionPropTypes,

        // Call parent onVehicleChange()
        onVehicleChange: PropTypes.func,

        // Call parent onCalculateUsageConsumption()
        onCalculateUsageConsumption: PropTypes.func
    };

    static defaultProps = {
        data: {},
        vehicleDetail: {},
        calculateUsageConsumption: true
    };

    /**
     * Calculating consumption on mount
     */
    componentDidMount = () => {
        this.props.onCalculateUsageConsumption();
    };

    render() {
        const {
            className, 
            vehicleDetail,
            usageConsumptionData, 
            onVehicleChange
        } = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        const classes = classNames(
            "container-form-step2",
            "p-4",
            {
                [className]: className !== undefined
            }
        );

        return (
            <div style={{ maxWidth:600,marginLeft:"auto",marginRight:"auto"}} className={classes} >

                <VehicleDetail
                    imageSrc={Api.getVehicleImageUrl(vehicleDetail.lcdv16)}
                    staticimg={staticimg}
                    model={vehicleDetail.model}
                    bodyStyle={vehicleDetail.bodyStyle}
                    commercialName={vehicleDetail.commercialName}
                    engine={vehicleDetail.engine}
                    transmission={vehicleDetail.transmission}
                    rims={vehicleDetail.rims}
                    onVehicleChange={onVehicleChange}
                />

                <div className={"col-9 col-md-7 content-result content-result-cccu"+client}>
                    {!usageConsumptionData ? (
                        <p className="consuption-before-result">
                            {t('Step1_form_calcul_in_progress')}
                        </p>
                        
                    ) : (
                        <React.Fragment>
                            <h6 className={"h6-cccu"}>{t('Step2_result_title')}<sup>(1)</sup>&nbsp;:</h6>

                            <span className="result-text result-text-cccu">{usageConsumptionData.consumption.toFixed(1)}{t('Step2_result_unit')}</span>
                        </React.Fragment>
                    )}
                </div>

              <div className="annotation-container annotation-container-cccu col-10 col-md-12 content-result text-justify ">
                    <Annotation>
                        {t('Step2_result_legals')}
                    </Annotation>
                </div>
            </div>
        )
    }
}

export default UsageConsumptionResult;


// WEBPACK FOOTER //
// ./src/components/steps/UsageConsumptionResult.js